import { SHOW_MAIN_NAVBAR, SHOW_SIDE_BAR, HIDE_SIDE_BAR, SHOW_MESSAGE_MODAL, HIDE_MESSAGE_MODAL, SHOW_UTIL_MODAL, HIDE_UTIL_MODAL, SHOW_CONTACT_INFO, HIDE_CONTACT_INFO, SHOW_PRODUCT_MODAL, HIDE_PRODUCT_MODAL, SHOW_ORDER_MODAL, HIDE_ORDER_MODAL, SHOW_CHILD_SIDE_BAR, HIDE_CHILD_SIDE_BAR, SHOW_PAKKET_MODAL, HIDE_PAKKET_MODAL } from '../actions/actionTypes'

const initialState = {
  isMainNavVisible: false,

  isSideBarVisible: false,
  sideBarContent: '',
  sideBarPlacement: 'right',

  isChildSideBarVisible: false,
  childSideBarContent: '',  

  isMessageModalVisible: false,
  messageType: '',
  messageTxt: '',

  isUtilModalVisible: false,
  utilComp: '',

  isContactInfoVisible: false,

  isProductModalVisible: false,
  editProduct: '',
  
  isPakketModalVisible: false,
  editPakket: '',

  isOrderModalVisible: false,
  selOrder: ''

}

export default function(state=initialState, action){
  switch(action.type){
    
    case SHOW_MAIN_NAVBAR:
      return{
        ...state,
        isMainNavVisible: action.payload
      }

    case SHOW_SIDE_BAR:
      return{
        ...state,
        isSideBarVisible: true,
        sideBarContent: action.payload.sidebar,
        sideBarPlacement: action.payload.placement ? action.payload.placement : 'right'
      }

    case HIDE_SIDE_BAR:
      return{
        ...state,
        isSideBarVisible: false,
        sideBarContent: ''
      }

      case SHOW_CHILD_SIDE_BAR:
        return{
          ...state,
          isChildSideBarVisible: true,
          childSideBarContent: action.payload
        }
  
      case HIDE_CHILD_SIDE_BAR:
        return{
          ...state,
          isChildSideBarVisible: false,
          childSideBarContent: ''
        }

    case SHOW_MESSAGE_MODAL:
      return{
        ...state,
        isMessageModalVisible: true,
        messageTxt: action.payload.txt,
        messageType: action.payload.type
      }

    case HIDE_MESSAGE_MODAL:
      return{
        ...state,
        isMessageModalVisible: false,
        messageTxt: '',
        messageType: ''
      }

    case SHOW_UTIL_MODAL:
      return{
        ...state,
        isUtilModalVisible: true,
        utilComp: action.payload
      }

    case HIDE_UTIL_MODAL:
      return{
        ...state,
        isUtilModalVisible: false,
        utilComp: ''
      }

    case SHOW_CONTACT_INFO:
      return{
        ...state,
        isContactInfoVisible: true
      }

    case HIDE_CONTACT_INFO:
      return{
        ...state,
        isContactInfoVisible: false
      }

    case SHOW_PRODUCT_MODAL:
      return{
        ...state,
        editProduct: action.payload,
        isProductModalVisible: true
      }

    case HIDE_PRODUCT_MODAL:
      return{
        ...state,
        isProductModalVisible: false,
        editProduct: ''
      }

      
    case SHOW_PAKKET_MODAL:{
      return{
        ...state,
        editPakket: action.payload,
        isPakketModalVisible: true
      }
    }

    case HIDE_PAKKET_MODAL:{
      return{
        ...state,
        editPakket: '',
        isPakketModalVisible: false
      }
    }


    case SHOW_ORDER_MODAL: 
    return{
      ...state,
      isOrderModalVisible: true,
      selOrder: action.payload
    }

    case HIDE_ORDER_MODAL:
      return{
        ...state,
        isOrderModalVisible: false,
        selOrder: ''
      }
      
    default:
      return state
  }

}